export const creatorConstants = {
    COLLECT_CREATOR_DATA: 'COLLECT_CREATOR_DATA',
    INIT_COLLECT_CREATOR_DATA: 'INIT_COLLECT_CREATOR_DATA',
    SEND_TOP_CREATORS_MAIL: 'SEND_TOP_CREATORS_MAIL',
};
